// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Checkout from '../components/Checkout';
import {actions as CheckoutActions} from '../duck';
import {actions as PlansActions} from '../../tiers/duck';
import {actions as AccountConfigActions} from '../../profile/account/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    currency: state.currency.currency,
    country: state.country.country,
    contact: state.information.contact,
    // providers: state.paymentProviders.providers,
    store: state.store.store,
    isFetchingStore: state.store.isFetchingStore,
    user: state.auth.user,
    isSaving: state.checkout.isSaving,
    cardProfiles: state.checkout.cardProfiles,
    isFetchingCardProfiles: state.checkout.isFetchingCardProfiles,
    planSelected: state.tiersList.planSelected,
    planSelectedCurrency: state.tiersList.planSelectedCurrency,
    basicPlans: state.tiersList.basicPlans,
    proPlusPlans: state.tiersList.proPlusPlans,
    subscription: state.tiersList.currentSubscription,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    isFetchingSubscriptionSetting:
      state.accountConfig.isFetchingSubscriptionSetting,
    checkoutSummary: state.checkout.checkoutSummary,
    fetchPurchaseSummaryError: state.checkout.fetchPurchaseSummaryError,
    isPerformingCheckout: state.checkout.isPerformingCheckout,
    performCheckoutSuccess: state.checkout.performCheckoutSuccess,
    performCheckoutError: state.checkout.performCheckoutError,
    isSubscribing: state.checkout.isSubscribing,
    subscribeSuccess: state.checkout.subscribeSuccess,
    subscribeError: state.checkout.subscribeError,
    paymentProviders: state.checkout.paymentProviders,
    saveSubscriptionSettingSuccess: state.accountConfig.savingSuccess,
    saveSubscriptionSettingError:
      state.accountConfig.saveSubscriptionSettingError,
    isSavingSubscriptionSetting: state.accountConfig.isSaving,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CheckoutActions,
        ...PlansActions,
        ...AccountConfigActions,
      },
      dispatch
    )
)(Checkout);
